import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Data } from "../utils/data.js";
import { EventHandler } from "../utils/events";
import { breakpoints } from "../utils/helpers";
import { getDataAttributes, filterArrayByWhitelist } from "../utils/helpers.js";
import { bpEvents, bpList } from "../utils/breakpoints";
import { DATA_KEY, EVENT_KEY, defaultConfig, aria } from "./ef-collapsible.constants.js";
export var EfCollapsible = /*#__PURE__*/function () {
  function EfCollapsible(el, config) {
    _classCallCheck(this, EfCollapsible);

    this._el = el;
    this._config = this._getConfig(el, config);
    this._contentEl = this._getTarget(this._config);
    this._events = EventHandler;
    this._isCollapsed = this._config.collapsed;
    this._toggleText = this._config.toggleText;
    this._previousText = undefined;
    this._hasListeners = false;
    this._toggleHandle = this.toggle.bind(this);
    this._transitionHandle = this._transition.bind(this);
    this._breakpointHandle = this._handleBreakpoints.bind(this);
    Data.setData(el, DATA_KEY, this);

    this._init();
  }

  _createClass(EfCollapsible, [{
    key: "toggle",
    value: function toggle(e) {
      if (e && e.target.nodeName === "A") e.preventDefault();
      this._isCollapsed = !this._isCollapsed;

      this._setCollapsed(this._isCollapsed);

      this._toggleText && this._toggleContent(this._toggleText);
    }
  }, {
    key: "show",
    value: function show() {
      this._isCollapsed = false;

      this._setCollapsed(this._isCollapsed);

      this._toggleText && this._toggleContent(this._toggleText);
    }
  }, {
    key: "hide",
    value: function hide() {
      this._isCollapsed = true;

      this._setCollapsed(this._isCollapsed);

      this._toggleText && this._toggleContent(this._toggleText);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._reset();

      this._events.off(document, bpEvents.UPDATED, this._breakpointHandle);
    }
  }, {
    key: "_init",
    value: function _init() {
      if (this._config.breakpoints.length) {
        this._handleBreakpoints(breakpoints.current);

        this._events.on(document, bpEvents.UPDATED, this._breakpointHandle);
      } else {
        this._setup();
      }
    }
  }, {
    key: "_setup",
    value: function _setup() {
      this._el.setAttribute(aria.CONTROLS, this._contentEl.id);

      this._setCollapsed(this._isCollapsed);

      this._addListeners();
    }
  }, {
    key: "_reset",
    value: function _reset() {
      this._el.removeAttribute(aria.EXPANDED);

      this._el.removeAttribute(aria.CONTROLS);

      this._contentEl.removeAttribute(aria.HIDDEN);

      this._contentEl.style.height = "";

      this._removeListeners();
    }
  }, {
    key: "_addListeners",
    value: function _addListeners() {
      if (this._hasListeners) return;

      this._events.on(this._el, "click", this._toggleHandle);

      this._events.on(this._contentEl, "transitionend", this._transitionHandle);

      this._hasListeners = true;
    }
  }, {
    key: "_removeListeners",
    value: function _removeListeners() {
      this._events.off(this._el, "click", this._toggleHandle);

      this._contentEl.removeEventListener("transitionend", this._transitionHandle);

      this._hasListeners = false;
    }
  }, {
    key: "_handleBreakpoints",
    value: function _handleBreakpoints(bp) {
      if (typeof bp === "object") bp = bp.detail;

      if (this._config.breakpoints.includes(bp)) {
        this._setup();
      } else {
        this._reset();
      }
    }
  }, {
    key: "_transition",
    value: function _transition(e) {
      if (e.propertyName === "height" && !this._isCollapsed) {
        this._contentEl.style.height = "";
      }
    }
  }, {
    key: "_setCollapsed",
    value: function _setCollapsed(bool) {
      this._isCollapsed = bool;
      this._isCollapsed ? this._close() : this._open();
    }
  }, {
    key: "_open",
    value: function _open() {
      var _this = this;

      this._el.setAttribute(aria.EXPANDED, true);

      this._contentEl.setAttribute(aria.HIDDEN, false);

      this._contentEl.style.width = window.getComputedStyle(this._contentEl).width;
      this._contentEl.style.position = "absolute";
      this._contentEl.style.visibility = "hidden";
      this._contentEl.style.height = "auto";
      var height = window.getComputedStyle(this._contentEl).height;
      this._contentEl.style.width = "";
      this._contentEl.style.position = "";
      this._contentEl.style.visibility = "";
      this._contentEl.style.height = 0; // force reflow

      window.getComputedStyle(this._contentEl).height;
      setTimeout(function () {
        _this._contentEl.style.height = height;

        _this._events.trigger(_this._el, "".concat(EVENT_KEY, ".shown"));
      });
    }
  }, {
    key: "_close",
    value: function _close() {
      var _this2 = this;

      this._el.setAttribute(aria.EXPANDED, false);

      this._contentEl.setAttribute(aria.HIDDEN, true);

      this._contentEl.style.height = window.getComputedStyle(this._contentEl).height; // force reflow

      window.getComputedStyle(this._contentEl).height;
      setTimeout(function () {
        _this2._contentEl.style.height = 0;

        _this2._contentEl.setAttribute(aria.EXPANDED, false);

        _this2._contentEl.setAttribute(aria.HIDDEN, true);

        _this2._events.trigger(_this2._el, "".concat(EVENT_KEY, ".hidden"));
      });
    }
  }, {
    key: "_getConfig",
    value: function _getConfig(el, config) {
      var _config = _objectSpread(_objectSpread(_objectSpread({}, defaultConfig), typeof config === "object" && config ? config : {}), getDataAttributes(el));

      _config.collapsed = Boolean(_config.collapsed);
      _config.breakpoints = filterArrayByWhitelist(_config.breakpoints, bpList);
      return _config;
    }
  }, {
    key: "_getTarget",
    value: function _getTarget(config) {
      if (!config.target) {
        throw new Error("EfCollapsible: must provide target collapsible selector");
      }

      var _target = document.querySelector(config.target);

      if (!_target) {
        throw new Error("EfCollapsible: collapsible target '".concat(config.target, "' not found"));
      }

      return _target;
    }
  }, {
    key: "_toggleContent",
    value: function _toggleContent(str) {
      if (!this._previousText) this._previousText = this._el.textContent;
      this._el.textContent = this._el.textContent === this._previousText ? str : this._previousText;
    }
  }], [{
    key: "activate",
    value: function activate(el) {
      var data = Data.getData(el, DATA_KEY);

      if (!data) {
        data = new EfCollapsible(el);
      }

      return data;
    }
  }]);

  return EfCollapsible;
}();